<template>
  <div class="plan-box">
    <p class="sub-title">开始规划您的游轮假期</p>
    <div class="plan-steps">
      <div class="step-item" @click="handleBindTicket">
        <img class="item-icon" src="../../assets/plan_step1.png" alt="">
        <p class="item-text">绑定船票</p>
      </div>
      <img class="icon-arrow" src="../../assets/icons/icon_arrow_r.png" alt="">
      <div class="step-item" @click="handleBooking">
        <img class="item-icon" src="../../assets/plan_step2.png" alt="">
        <p class="item-text">选择活动</p>
      </div>
      <img class="icon-arrow" src="../../assets/icons/icon_arrow_r.png" alt="">
      <div class="step-item" @click="handleQuestion">
        <img class="item-icon" src="../../assets/plan_step3.png" alt="">
        <p class="item-text">登轮支付</p>
      </div>
      <img class="icon-arrow" src="../../assets/icons/icon_arrow_r.png" alt="">
      <div class="step-item">
        <img class="item-icon" src="../../assets/plan_step4.png" alt="">
        <p class="item-text">享受假期</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BeginnersTipsPlan',
  methods: {
    handleBindTicket () {
      if (this.$store.getters.isLogin && this.$store.state.bindTicket) return
      this.$router.push(this.$store.getters.isLogin ? '/bind_ticket' : '/login')
    },
    handleBooking () {
      this.$router.push({
        name: 'Index',
        params: {
          fromIndex: '1'
        }
      })
    },
    handleQuestion () {
      this.$router.push({
        name: 'PageQuestion',
        params: {
          fromIndex: '1'
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.plan-box{
  background: url(../../assets/beginners_tips_bj.jpg) no-repeat center;
  background-size: cover;
  padding: 60px 0 70px;
  .sub-title {
    position: relative;
    font-size: 30px;
    font-weight: bold;
    line-height: 54px;
    text-align: center;
    color: @main-gray7;
    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      z-index: 1;
      width: 190px;
      height: 4px;
      margin-top: -2px;
      background-color: @second-color;
    }
    &::before {
      left: 20px;
    }
    &::after {
      right: 20px;
    }
    &.package {
      &::before,
      &::after {
        width: 280px;
      }
    }
  }
  .plan-steps {
    display: flex;
    justify-content: space-between;
    padding: 30px 48px 46px;
    .step-item {
      flex: none;
      width: 112px;
      .item-icon {
        display: block;
        width: 100%;
      }
      .item-text {
        margin-top: 12px;
        font-size: 24px;
        line-height: 42px;
        text-align: center;
        color: @main-gray7;
      }
    }
    .icon-arrow {
      height: 16px;
      margin-top: 52px;
    }
  }
}
</style>
